import React from "react";

const TelegramIcon = ({ size = "16" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_5191_8691)">
        <path
          d="M8.5 0C6.37875 0 4.3425 0.843375 2.84375 2.34313C1.34347 3.84348 0.500429 5.87823 0.5 8C0.5 10.1209 1.34375 12.1571 2.84375 13.6569C4.3425 15.1566 6.37875 16 8.5 16C10.6213 16 12.6575 15.1566 14.1562 13.6569C15.6562 12.1571 16.5 10.1209 16.5 8C16.5 5.87913 15.6562 3.84288 14.1562 2.34313C12.6575 0.843375 10.6213 0 8.5 0Z"
          fill="url(#paint0_linear_5191_8691)"
        />
        <path
          d="M4.12058 7.91553C6.45308 6.89953 8.00808 6.22969 8.78558 5.90603C11.0081 4.9819 11.4693 4.8214 11.7706 4.81597C11.8368 4.8149 11.9843 4.83128 12.0806 4.90909C12.1606 4.97472 12.1831 5.06347 12.1943 5.12578C12.2043 5.18803 12.2181 5.3299 12.2068 5.44065C12.0868 6.70565 11.5656 9.7754 11.3006 11.1923C11.1893 11.7918 10.9681 11.9928 10.7543 12.0124C10.2893 12.0552 9.93683 11.7054 9.48683 11.4105C8.78308 10.9489 8.38558 10.6617 7.70183 10.2113C6.91183 9.69078 7.42433 9.40465 7.87433 8.93715C7.99183 8.81478 10.0393 6.9529 10.0781 6.78403C10.0831 6.7629 10.0881 6.68415 10.0406 6.64265C9.99433 6.60103 9.92558 6.61528 9.87558 6.62653C9.80433 6.64253 8.68058 7.38603 6.50058 8.8569C6.18183 9.07615 5.89308 9.18303 5.63308 9.1774C5.34808 9.17128 4.79808 9.0159 4.38933 8.88315C3.88933 8.72028 3.49058 8.63415 3.52558 8.35753C3.54308 8.21353 3.74183 8.06615 4.12058 7.91553Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_5191_8691"
          x1="800.5"
          y1="0"
          x2="800.5"
          y2="1600"
          gradientUnits="userSpaceOnUse"
        >
          <stop stop-color="#2AABEE" />
          <stop offset="1" stop-color="#229ED9" />
        </linearGradient>
        <clipPath id="clip0_5191_8691">
          <rect
            width={size}
            height={size}
            fill="white"
            transform="translate(0.5)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default TelegramIcon;
